import * as React from 'react';

import { Icon } from '@gitbook/spine-icons';
import { ActionableContainer, Button, Description, Group, Heading } from '@gitbook/spine-react';

import { useSiteContext } from '../../../../../state';
import { useSiteUnpublish } from '../../Plan';

export const UnpublishSite = React.memo(function UnpublishSite() {
    const { site } = useSiteContext();

    if (!site.published) {
        return null;
    }

    return (
        <ActionableContainer orientation="horizontal">
            <Group>
                <Heading>Unpublish site</Heading>
                <Description>
                    Your site will no longer be available to external audiences. You can republish
                    your site with the same URL at any time.
                </Description>
            </Group>
            <UnpublishSiteButton />
        </ActionableContainer>
    );
});

function UnpublishSiteButton() {
    const { site, organizationId } = useSiteContext();
    const unpublishSite = useSiteUnpublish(organizationId, site.id);

    return (
        <Button
            kind="danger"
            size="medium"
            leadingIcon={Icon.Unpublish}
            label="Unpublish site"
            onPress={unpublishSite}
        />
    );
}
